import React from "react";

import { CheckYourEmail } from '../../components/checkYourEmail/checkYourEmail.component';

export const VerifyEmailMessage: React.FC = () => {
  return <CheckYourEmail  content="activate account" />
};
